import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=dfea0b82&"
import script from "./Wrapper.vue?vue&type=script&lang=ts&"
export * from "./Wrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalImageGallery: require('/tmp/build_71ad00c4/src/components/modal/ImageGallery/ImageGallery.vue').default})
